import reducer from './dialogs.reducer';
import * as selector from './drawers.selector';
import * as constant from './dialogs.constant';
import subscriber from './drawers.subscriber';
import saga from './drawers.saga';

export default {
  reducer,
  constant,
  selector,
  subscriber,
  saga,
  name: constant.NAME,
};
